module.exports = __webpack_public_path__ + "static/media/hand_click_red.bab5c2e1.svg";